import {
  CRMMarket,
  Market,
  MarketConfigs,
  MarketSlug,
  TaxonomyMarketAbbreviaton,
} from './types';

export const marketConfigs: Partial<MarketConfigs> = {
  [Market.AgriEnvironmental]: {
    eLabMarketSlug: MarketSlug.AgriEnvironmental,
    taxonomyMarketAbbreviaton: TaxonomyMarketAbbreviaton.AG,
    crmMarketSegment: CRMMarket.AgriEnvironmental,
  },
  [Market.FoodNutrition]: {
    eLabMarketSlug: MarketSlug.FoodNutrition,
    taxonomyMarketAbbreviaton: TaxonomyMarketAbbreviaton.FH,
    crmMarketSegment: CRMMarket.FoodNutrition,
  },
  [Market.HomeCareIndustrialCleaning]: {
    eLabMarketSlug: MarketSlug.HomeCareIndustrialCleaning,
    taxonomyMarketAbbreviaton: TaxonomyMarketAbbreviaton.HCIC,
    crmMarketSegment: CRMMarket.HomeCareIndustrialCleaning,
  },
  [Market.PersonalCare]: {
    eLabMarketSlug: MarketSlug.PersonalCare,
    taxonomyMarketAbbreviaton: TaxonomyMarketAbbreviaton.PC,
    crmMarketSegment: CRMMarket.PersonalCare,
  },
};
